import { render, staticRenderFns } from "./honorList.vue?vue&type=template&id=0f04faee&scoped=true&"
import script from "./honorList.vue?vue&type=script&lang=js&"
export * from "./honorList.vue?vue&type=script&lang=js&"
import style0 from "./honorList.vue?vue&type=style&index=0&id=0f04faee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f04faee",
  null
  
)

export default component.exports